export class OlServiceModel {

    constructor(id, service) {
        this.id = id
        this.service = service
    }
}
